import { render, staticRenderFns } from "./circularLoader.vue?vue&type=template&id=0effeb86&scoped=true&"
import script from "./circularLoader.vue?vue&type=script&lang=js&"
export * from "./circularLoader.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0effeb86",
  null
  
)

export default component.exports